import React from 'react'

// Prefix covering this query for every brandAccountId. React Query matches
// keys by prefix, so callers without a specific id can invalidate through it.
export const BRAND_ACCOUNT_AI_ENABLED_QUERY_KEY_PREFIX =
  'UseBrandAccountAiEnabledQuery_Main'

export const useBrandAccountAiEnabledQueryKey = (
  brandAccountId: string | undefined,
) =>
  React.useMemo(
    () =>
      [BRAND_ACCOUNT_AI_ENABLED_QUERY_KEY_PREFIX, { brandAccountId }] as const,
    [brandAccountId],
  )
